import React, {useEffect, useMemo} from 'react';
import {PageConstructor} from '@gravity-ui/page-constructor';
import {useThemeValue} from '@gravity-ui/uikit';

import {Lang, Theme} from '~shared/models/settings';

import {crossReachGoal} from '~ui/services/metrika';

import {PromoPageFooter} from './PromoPageFooter';
import {PromoPageHeader} from './PromoPageHeader';

import {PromoPageCard} from './PromoPageCard';
import {SHOW_GOAL} from './constants';

import {getPromoPageConfig} from './config';

import './PromoPage.scss';

import {cnPromoPage} from './PromoPage.classname';

interface PromoPageProps {
    lang?: Lang;
}

export const PromoPage: React.FC<PromoPageProps> = ({lang = Lang.Ru}) => {
    const theme = useThemeValue();

    const config = useMemo(() => getPromoPageConfig(lang, theme as Theme), [lang, theme]);

    useEffect(() => {
        crossReachGoal(SHOW_GOAL);
    }, []);

    return (
        <div className={cnPromoPage()}>
            <PromoPageHeader content={config} />
            <PageConstructor
                content={config}
                custom={{
                    blocks: {
                        card: PromoPageCard,
                    },
                }}
            />
            <PromoPageFooter lang={lang} />
        </div>
    );
};
